import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const rebateCsvTransformStep = defineStepConfig({
  type: "rebate_csv_transform",
  name: "Rebate CSV Transform",
  description:
    "Apply business rules via AI workflow to produce the final transformed CSV",
  category: "Transformation",
  libraryModule: "Rebates",

  inputSchema: z.object({
    rebateSessionId: z.string().uuid(),
  }),

  outputSchema: z.object({
    rebateSessionId: z.string().uuid(),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "15 minutes",
  },
});
